export enum ROUTES {
  // PUBLIC ROUTES
  INDEX = '/',
  CHANGE_PASSWORD = '/:companyPath?/changePassword',
  CHANGE_PASSWORD_TOKEN = '/:companyPath?/changePassword/:token',
  LOGIN = '/:companyPath?/login',
  LOGIN_NO_BRANDING = '/login',
  EMAIL_VERIFICATION = '/:companyPath?/emailVerification',
  REGISTRATION = '/:companyPath?/registration/:token',
  SSO = '/:companyPath?/sso',
  REDIRECT_ERROR = '/error',

  // unscoped private routes
  REVISIONS = '/tenant/:tenantID/revision/:entityType/:entityID',
  TEST = '/test', // useful for testing route errors

  // tenant scoped routes (HOME / Dashboard)
  DASHBOARD = '/tenant/:tenantID', // layout route
  ACTIVITY_FEED = '/tenant/:tenantID/activity-feed',
  PROPERTIES = '/tenant/:tenantID/properties',
  PROPERTY_CREATE = '/tenant/:tenantID/properties/create',
  PROPERTY_GROUPS = '/tenant/:tenantID/property-groups',
  PROPERTY_GROUP_CREATE = '/tenant/:tenantID/property-groups/create',
  COMPANY_SETUP = '/tenant/:tenantID/company-setup',
  PERMISSIONS = '/tenant/:tenantID/permissions',

  REPORTS = '/tenant/:tenantID/reports',
  REPORTS_JOBS_BY_PROPERTY = '/tenant/:tenantID/reports/jobs-by-property',

  JOBS = '/tenant/:tenantID/jobs',
  JOBS_DETAILS = '/tenant/:tenantID/jobs/:jobID',
  JOBS_CREATE = '/tenant/:tenantID/jobs/create',

  PEOPLE = '/tenant/:tenantID/people',
  USERS = '/tenant/:tenantID/people/users',
  USERS_FORM = '/tenant/:tenantID/people/users/:userID',
  CONTACTS = '/tenant/:tenantID/people/contacts',
  CONTACTS_FORM = '/tenant/:tenantID/people/contacts/:contactID',

  // User profile route
  USER_PROFILE = '/tenant/:tenantID/user-profile',

  RULES_CONFIG = '/tenant/:tenantID/rule-config',
  RULES = '/tenant/:tenantID/rule-config/rules',
  RULES_FORM = '/tenant/:tenantID/rule-config/rules/:ruleID',
  RULESETS = '/tenant/:tenantID/rule-config/rulesets',
  RULESETS_FORM = '/tenant/:tenantID/rule-config/rulesets/:rulesetID',
  VIOLATIONS = '/tenant/:tenantID/rule-config/violations',

  // users with multiple tenants
  TENANT_SELECT = '/tenant/:tenantID/tenant-select',

  //super admin only routes
  COMMAND_CENTER = '/tenant/:tenantID/command-center',
  TENANTS = '/tenant/:tenantID/command-center/tenants',
  TENANTS_FORM = '/tenant/:tenantID/command-center/tenants/:targetTenantID',
  TENANT_GROUPS = '/tenant/:tenantID/command-center/tenant-groups',
  TENANT_GROUPS_FORM = '/tenant/:tenantID/command-center/tenant-groups/:tenantGroupID',
  SYSTEMS = '/tenant/:tenantID/command-center/systems',
  SYSTEMS_FORM = '/tenant/:tenantID/command-center/systems/:systemID',
  HEALTH = '/tenant/:tenantID/command-center/health',
  PROPERTY_IMPORT = '/tenant/:tenantID/command-center/property-importer',

  // property details routes
  PROPERTY = '/tenant/:tenantID/property/:propertyID',
  PROPERTY_BRANDING = '/tenant/:tenantID/property/:propertyID/branding',
  PROPERTY_DO_NOT_TOW = '/tenant/:tenantID/property/:propertyID/donottow',
  PROPERTY_DO_NOT_TOW_FORM = '/tenant/:tenantID/property/:propertyID/donottow/:dntID',
  PROPERTY_FILES = '/tenant/:tenantID/property/:propertyID/files',
  PROPERTY_QR_CODES = '/tenant/:tenantID/property/:propertyID/qrCodes',
  PROPERTY_QR_CODES_FORM = '/tenant/:tenantID/property/:propertyID/qrCodes/:qrCodeID',

  // property people tab routes
  PROPERTY_PEOPLE = '/tenant/:tenantID/property/:propertyID/people',
  PROPERTY_CONTACTS = '/tenant/:tenantID/property/:propertyID/people/contacts',
  PROPERTY_CONTACTS_FORM = '/tenant/:tenantID/property/:propertyID/people/contacts/:contactID',
  PROPERTY_USERS = '/tenant/:tenantID/property/:propertyID/people/users',
  PROPERTY_USERS_FORM = '/tenant/:tenantID/property/:propertyID/people/users/:userID',

  // property rules tab routes
  PROPERTY_RULES_CONFIG = '/tenant/:tenantID/property/:propertyID/rule-config',
  PROPERTY_RULES = '/tenant/:tenantID/property/:propertyID/rule-config/rules',
  PROPERTY_RULES_FORM = '/tenant/:tenantID/property/:propertyID/rule-config/rules/:ruleID',
  PROPERTY_RULESETS = '/tenant/:tenantID/property/:propertyID/rule-config/rulesets',
  PROPERTY_RULESETS_FORM = '/tenant/:tenantID/property/:propertyID/rule-config/rulesets/:rulesetID',
  PROPERTY_INSTRUCTIONS = '/tenant/:tenantID/property/:propertyID/rule-config/instructions',

  // property permits tab routes
  PROPERTY_PERMITS = '/tenant/:tenantID/property/:propertyID/permits',
  PROPERTY_PERMIT_DETAILS = '/tenant/:tenantID/property/:propertyID/permits/:permitID',
  PROPERTY_PERMIT_REFUNDS = '/tenant/:tenantID/property/:propertyID/permits/:permitID/refunds',
  PROPERTY_PERMIT_HISTORY = '/tenant/:tenantID/property/:propertyID/permits/:permitID/history',
  PROPERTY_PERMITS_IMPORT = '/tenant/:tenantID/property/:propertyID/permits/import',

  PROPERTY_PERMIT_TYPES = '/tenant/:tenantID/property/:propertyID/permitTypes',
  PROPERTY_PERMIT_TYPES_FORM = '/tenant/:tenantID/property/:propertyID/permitTypes/:permitTypeID',

  PROPERTY_JOBS = '/tenant/:tenantID/property/:propertyID/jobs',
  PROPERTY_JOBS_CREATE = '/tenant/:tenantID/property/:propertyID/jobs/create',
  PROPERTY_JOBS_DETAILS = '/tenant/:tenantID/property/:propertyID/jobs/:jobID',

  // property group scoped routes
  PROPERTY_GROUP = '/tenant/:tenantID/property-group/:groupID',
  PROPERTY_GROUP_BRANDING = '/tenant/:tenantID/property-group/:groupID/branding',
  PROPERTY_GROUP_FILES = '/tenant/:tenantID/property-group/:groupID/files',
  PROPERTY_GROUP_QR_CODES = '/tenant/:tenantID/property-group/:groupID/qrCodes',
  PROPERTY_GROUP_QR_CODES_FORM = '/tenant/:tenantID/property-group/:groupID/qrCodes/:qrCodeID',
  PROPERTY_GROUP_DO_NOT_TOW = '/tenant/:tenantID/property-group/:groupID/donottow',
  PROPERTY_GROUP_DO_NOT_TOW_FORM = '/tenant/:tenantID/property-group/:groupID/donottow/:dntID',

  // property group people tab routes
  PROPERTY_GROUP_PEOPLE = '/tenant/:tenantID/property-group/:groupID/people',
  PROPERTY_GROUP_CONTACTS = '/tenant/:tenantID/property-group/:groupID/people/contacts',
  PROPERTY_GROUP_CONTACTS_FORM = '/tenant/:tenantID/property-group/:groupID/people/contacts/:contactID',
  PROPERTY_GROUP_USERS = '/tenant/:tenantID/property-group/:groupID/people/users',
  PROPERTY_GROUP_USERS_FORM = '/tenant/:tenantID/property-group/:groupID/people/users/:userID',

  // property group rules tab routes
  PROPERTY_GROUP_RULES_CONFIG = '/tenant/:tenantID/property-group/:groupID/rule-config',
  PROPERTY_GROUP_RULES = '/tenant/:tenantID/property-group/:groupID/rule-config/rules',
  PROPERTY_GROUP_RULES_FORM = '/tenant/:tenantID/property-group/:groupID/rule-config/rules/:ruleID',
  PROPERTY_GROUP_RULESETS = '/tenant/:tenantID/property-group/:groupID/rule-config/rulesets',
  PROPERTY_GROUP_RULESETS_FORM = '/tenant/:tenantID/property-group/:groupID/rule-config/rulesets/:rulesetID',

  PROPERTY_GROUP_PERMIT_TYPES = '/tenant/:tenantID/property-group/:groupID/permitTypes',
  PROPERTY_GROUP_PERMIT_TYPES_FORM = '/tenant/:tenantID/property-group/:groupID/permitTypes/:permitTypeID',

  PROPERTY_GROUP_PROPERTIES = '/tenant/:tenantID/property-group/:groupID/properties',
  PROPERTY_GROUP_PROPERTIES_CREATE = '/tenant/:tenantID/property-group/:groupID/properties/create',

  PROPERTY_GROUP_JOBS = '/tenant/:tenantID/property-group/:groupID/jobs',
  PROPERTY_GROUP_JOBS_CREATE = '/tenant/:tenantID/property-group/:groupID/jobs/create',
  PROPERTY_GROUP_JOBS_DETAILS = '/tenant/:tenantID/property-group/:groupID/jobs/:jobID',

  // resoure-only routes (no element)
  CANCEL_JOB_REASONS = '/tenant/:tenantID/jobs/cancelReasons',
  JOB_PROPERTY_DATA = '/tenant/:tenantID/property/:propertyID/job-create-data',
}

// routes that do not require authentication
export const publicRoutes: Array<ROUTES> = [
  ROUTES.LOGIN,
  ROUTES.SSO,
  ROUTES.REGISTRATION,
  ROUTES.CHANGE_PASSWORD,
  ROUTES.INDEX,
  ROUTES.EMAIL_VERIFICATION,
];

// routes that require authentication but not permissions
export const commonRoutes: Array<ROUTES> = [
  ROUTES.DASHBOARD,
  ROUTES.JOBS,
  ROUTES.USER_PROFILE, // user can always access their own profile
  ROUTES.REPORTS, // per-report permissions (this might move)
  ROUTES.ACTIVITY_FEED, // manages it's own permissions
  ROUTES.TENANT_SELECT, // for user.tenants.length > 1 only
];

// routes that require authentication and permissions
export const privateRoutes: Array<ROUTES> = [
  ROUTES.REVISIONS,
  ROUTES.TEST,

  // reports
  ROUTES.REPORTS_JOBS_BY_PROPERTY,

  // tenant scoped
  ROUTES.JOBS_DETAILS,
  ROUTES.JOBS_CREATE,
  ROUTES.ACTIVITY_FEED,
  ROUTES.PROPERTIES,
  ROUTES.PROPERTY_GROUPS,
  ROUTES.COMPANY_SETUP,
  ROUTES.PERMISSIONS,
  ROUTES.RULES_CONFIG,
  ROUTES.RULES,
  ROUTES.RULESETS,
  ROUTES.RULES_FORM,
  ROUTES.RULESETS_FORM,
  ROUTES.VIOLATIONS,
  ROUTES.USERS,
  ROUTES.USERS_FORM,
  ROUTES.CONTACTS,
  ROUTES.CONTACTS_FORM,
  ROUTES.PEOPLE,

  // property scoped
  ROUTES.PROPERTY,
  ROUTES.PROPERTY_CREATE,
  ROUTES.PROPERTY_DO_NOT_TOW,
  ROUTES.PROPERTY_DO_NOT_TOW_FORM,
  ROUTES.PROPERTY_CONTACTS,
  ROUTES.PROPERTY_CONTACTS_FORM,
  ROUTES.PROPERTY_USERS,
  ROUTES.PROPERTY_USERS_FORM,
  ROUTES.PROPERTY_RULES_CONFIG,
  ROUTES.PROPERTY_RULES,
  ROUTES.PROPERTY_RULES_FORM,
  ROUTES.PROPERTY_RULESETS,
  ROUTES.PROPERTY_RULESETS_FORM,
  ROUTES.PROPERTY_INSTRUCTIONS,
  ROUTES.PROPERTY_PERMITS,
  ROUTES.PROPERTY_PERMIT_DETAILS,
  ROUTES.PROPERTY_PERMIT_REFUNDS,
  ROUTES.PROPERTY_PERMIT_HISTORY,
  ROUTES.PROPERTY_PERMITS_IMPORT,
  ROUTES.PROPERTY_FILES,
  ROUTES.PROPERTY_BRANDING,
  ROUTES.PROPERTY_JOBS,
  ROUTES.PROPERTY_JOBS_DETAILS,
  ROUTES.PROPERTY_JOBS_CREATE,
  ROUTES.PROPERTY_PERMIT_TYPES,
  ROUTES.PROPERTY_PERMIT_TYPES_FORM,
  ROUTES.PROPERTY_QR_CODES,
  ROUTES.PROPERTY_QR_CODES_FORM,

  // property group scoped
  ROUTES.PROPERTY_GROUP,
  ROUTES.PROPERTY_GROUP_CREATE,
  ROUTES.PROPERTY_GROUP_DO_NOT_TOW,
  ROUTES.PROPERTY_GROUP_DO_NOT_TOW_FORM,
  ROUTES.PROPERTY_GROUP_CONTACTS,
  ROUTES.PROPERTY_GROUP_CONTACTS_FORM,
  ROUTES.PROPERTY_GROUP_USERS,
  ROUTES.PROPERTY_GROUP_USERS_FORM,
  ROUTES.PROPERTY_GROUP_RULES_CONFIG,
  ROUTES.PROPERTY_GROUP_RULES,
  ROUTES.PROPERTY_GROUP_RULES_FORM,
  ROUTES.PROPERTY_GROUP_RULESETS,
  ROUTES.PROPERTY_GROUP_RULESETS_FORM,
  ROUTES.PROPERTY_GROUP_FILES,
  ROUTES.PROPERTY_GROUP_BRANDING,
  ROUTES.PROPERTY_GROUP_JOBS,
  ROUTES.PROPERTY_GROUP_JOBS_DETAILS,
  ROUTES.PROPERTY_GROUP_JOBS_CREATE,
  ROUTES.PROPERTY_GROUP_PROPERTIES,
  ROUTES.PROPERTY_GROUP_PROPERTIES_CREATE,
  ROUTES.PROPERTY_GROUP_PERMIT_TYPES,
  ROUTES.PROPERTY_GROUP_PERMIT_TYPES_FORM,
  ROUTES.PROPERTY_GROUP_QR_CODES,
  ROUTES.PROPERTY_GROUP_QR_CODES_FORM,
];

// routes that are only available to super admins
export const superAdminRoutes: Array<ROUTES> = [
  ROUTES.SYSTEMS,
  ROUTES.SYSTEMS_FORM,
  ROUTES.TENANTS_FORM,
  ROUTES.TENANT_GROUPS,
  ROUTES.TENANT_GROUPS_FORM,
  ROUTES.TENANTS_FORM,
  ROUTES.PROPERTY_IMPORT,
];

/**
 * @name routeWithParams
 * @param route <ROUTES> - the route to use
 * @param paramArr <string|number[]> - an array of params to replace in the route in order of appearance
 */
export function routeWithParams(
  route: ROUTES,
  paramArr: Array<number | string>,
): string {
  const stringArr: string[] = paramArr.map((param) => {
    return typeof param === 'number' ? param.toString() : param;
  });

  switch (route as ROUTES) {
    // Routes with only tenantID
    case ROUTES.DASHBOARD:
    case ROUTES.COMMAND_CENTER:
    case ROUTES.HEALTH:
    case ROUTES.TENANTS:
    case ROUTES.PROPERTIES:
    case ROUTES.PROPERTY_CREATE:
    case ROUTES.PROPERTY_GROUPS:
    case ROUTES.PROPERTY_GROUP_CREATE:
    case ROUTES.COMPANY_SETUP:
    case ROUTES.PERMISSIONS:
    case ROUTES.REPORTS:
    case ROUTES.REPORTS_JOBS_BY_PROPERTY:
    case ROUTES.ACTIVITY_FEED:
    case ROUTES.JOBS:
    case ROUTES.JOBS_CREATE:
    case ROUTES.USERS:
    case ROUTES.CONTACTS:
    case ROUTES.SYSTEMS:
    case ROUTES.TENANT_GROUPS:
    case ROUTES.TENANT_SELECT:
    case ROUTES.PEOPLE:
    case ROUTES.USER_PROFILE:
    case ROUTES.RULES_CONFIG:
    case ROUTES.RULES:
    case ROUTES.RULESETS:
    case ROUTES.VIOLATIONS:
    case ROUTES.CANCEL_JOB_REASONS:
    case ROUTES.PROPERTY_IMPORT: {
      return route.replace(':tenantID', stringArr[0]);
    }

    // Routes with tenantID and one other ID
    case ROUTES.USERS_FORM: {
      return route
        .replace(':tenantID', stringArr[0])
        .replace(':userID', stringArr[1]);
    }
    case ROUTES.CONTACTS_FORM: {
      return route
        .replace(':tenantID', stringArr[0])
        .replace(':contactID', stringArr[1]);
    }
    case ROUTES.RULES_FORM: {
      return route
        .replace(':tenantID', stringArr[0])
        .replace(':ruleID', stringArr[1]);
    }
    case ROUTES.RULESETS_FORM: {
      return route
        .replace(':tenantID', stringArr[0])
        .replace(':rulesetID', stringArr[1]);
    }
    case ROUTES.JOBS_DETAILS: {
      return route
        .replace(':tenantID', stringArr[0])
        .replace(':jobID', stringArr[1]);
    }
    case ROUTES.TENANTS_FORM: {
      return route
        .replace(':tenantID', stringArr[0])
        .replace(':targetTenantID', stringArr[1]);
    }
    case ROUTES.TENANT_GROUPS_FORM: {
      return route
        .replace(':tenantID', stringArr[0])
        .replace(':tenantGroupID', stringArr[1]);
    }
    case ROUTES.SYSTEMS_FORM: {
      return route
        .replace(':tenantID', stringArr[0])
        .replace(':systemID', stringArr[1]);
    }

    // Property scoped routes
    case ROUTES.PROPERTY:
    case ROUTES.PROPERTY_DO_NOT_TOW:
    case ROUTES.PROPERTY_CONTACTS:
    case ROUTES.PROPERTY_USERS:
    case ROUTES.PROPERTY_RULES:
    case ROUTES.PROPERTY_RULESETS:
    case ROUTES.PROPERTY_INSTRUCTIONS:
    case ROUTES.PROPERTY_QR_CODES:
    case ROUTES.PROPERTY_PERMIT_TYPES:
    case ROUTES.PROPERTY_FILES:
    case ROUTES.PROPERTY_PERMITS:
    case ROUTES.PROPERTY_PERMITS_IMPORT:
    case ROUTES.PROPERTY_BRANDING:
    case ROUTES.PROPERTY_JOBS:
    case ROUTES.PROPERTY_PEOPLE:
    case ROUTES.PROPERTY_RULES_CONFIG:
    case ROUTES.PROPERTY_JOBS_CREATE:
    case ROUTES.JOB_PROPERTY_DATA: {
      return route
        .replace(':tenantID', stringArr[0])
        .replace(':propertyID', stringArr[1]);
    }
    case ROUTES.PROPERTY_CONTACTS_FORM: {
      return route
        .replace(':tenantID', stringArr[0])
        .replace(':propertyID', stringArr[1])
        .replace(':contactID', stringArr[2]);
    }
    case ROUTES.PROPERTY_USERS_FORM: {
      return route
        .replace(':tenantID', stringArr[0])
        .replace(':propertyID', stringArr[1])
        .replace(':userID', stringArr[2]);
    }
    case ROUTES.PROPERTY_RULES_FORM: {
      return route
        .replace(':tenantID', stringArr[0])
        .replace(':propertyID', stringArr[1])
        .replace(':ruleID', stringArr[2]);
    }
    case ROUTES.PROPERTY_RULESETS_FORM: {
      return route
        .replace(':tenantID', stringArr[0])
        .replace(':propertyID', stringArr[1])
        .replace(':rulesetID', stringArr[2]);
    }
    case ROUTES.PROPERTY_QR_CODES_FORM: {
      return route
        .replace(':tenantID', stringArr[0])
        .replace(':propertyID', stringArr[1])
        .replace(':qrCodeID', stringArr[2]);
    }
    case ROUTES.PROPERTY_PERMIT_TYPES_FORM: {
      return route
        .replace(':tenantID', stringArr[0])
        .replace(':propertyID', stringArr[1])
        .replace(':permitTypeID', stringArr[2]);
    }
    case ROUTES.PROPERTY_DO_NOT_TOW_FORM: {
      return route
        .replace(':tenantID', stringArr[0])
        .replace(':propertyID', stringArr[1])
        .replace(':dntID', stringArr[2]);
    }
    case ROUTES.PROPERTY_PERMIT_DETAILS:
    case ROUTES.PROPERTY_PERMIT_REFUNDS:
    case ROUTES.PROPERTY_PERMIT_HISTORY: {
      return route
        .replace(':tenantID', stringArr[0])
        .replace(':propertyID', stringArr[1])
        .replace(':permitID', stringArr[2]);
    }
    case ROUTES.PROPERTY_JOBS_DETAILS: {
      return route
        .replace(':tenantID', stringArr[0])
        .replace(':propertyID', stringArr[1])
        .replace(':jobID', stringArr[2]);
    }

    // Property group scoped routes
    case ROUTES.PROPERTY_GROUP:
    case ROUTES.PROPERTY_GROUP_DO_NOT_TOW:
    case ROUTES.PROPERTY_GROUP_CONTACTS:
    case ROUTES.PROPERTY_GROUP_USERS:
    case ROUTES.PROPERTY_GROUP_RULES:
    case ROUTES.PROPERTY_GROUP_RULES_CONFIG:
    case ROUTES.PROPERTY_GROUP_RULESETS:
    case ROUTES.PROPERTY_GROUP_QR_CODES:
    case ROUTES.PROPERTY_GROUP_PERMIT_TYPES:
    case ROUTES.PROPERTY_GROUP_FILES:
    case ROUTES.PROPERTY_GROUP_PROPERTIES:
    case ROUTES.PROPERTY_GROUP_PROPERTIES_CREATE:
    case ROUTES.PROPERTY_GROUP_PEOPLE:
    case ROUTES.PROPERTY_GROUP_BRANDING:
    case ROUTES.PROPERTY_GROUP_JOBS:
    case ROUTES.PROPERTY_GROUP_JOBS_CREATE: {
      return route
        .replace(':tenantID', stringArr[0])
        .replace(':groupID', stringArr[1]);
    }
    case ROUTES.PROPERTY_GROUP_CONTACTS_FORM: {
      return route
        .replace(':tenantID', stringArr[0])
        .replace(':groupID', stringArr[1])
        .replace(':contactID', stringArr[2]);
    }
    case ROUTES.PROPERTY_GROUP_USERS_FORM: {
      return route
        .replace(':tenantID', stringArr[0])
        .replace(':groupID', stringArr[1])
        .replace(':userID', stringArr[2]);
    }
    case ROUTES.PROPERTY_GROUP_RULES_FORM: {
      return route
        .replace(':tenantID', stringArr[0])
        .replace(':groupID', stringArr[1])
        .replace(':ruleID', stringArr[2]);
    }
    case ROUTES.PROPERTY_GROUP_RULESETS_FORM: {
      return route
        .replace(':tenantID', stringArr[0])
        .replace(':groupID', stringArr[1])
        .replace(':rulesetID', stringArr[2]);
    }
    case ROUTES.PROPERTY_GROUP_QR_CODES_FORM: {
      return route
        .replace(':tenantID', stringArr[0])
        .replace(':groupID', stringArr[1])
        .replace(':qrCodeID', stringArr[2]);
    }
    case ROUTES.PROPERTY_GROUP_PERMIT_TYPES_FORM: {
      return route
        .replace(':tenantID', stringArr[0])
        .replace(':groupID', stringArr[1])
        .replace(':permitTypeID', stringArr[2]);
    }
    case ROUTES.PROPERTY_GROUP_DO_NOT_TOW_FORM: {
      return route
        .replace(':tenantID', stringArr[0])
        .replace(':groupID', stringArr[1])
        .replace(':dntID', stringArr[2]);
    }
    case ROUTES.PROPERTY_GROUP_JOBS_DETAILS: {
      return route
        .replace(':tenantID', stringArr[0])
        .replace(':groupID', stringArr[1])
        .replace(':jobID', stringArr[2]);
    }

    // Public routes with companyPath and token
    case ROUTES.CHANGE_PASSWORD_TOKEN:
    case ROUTES.REGISTRATION: {
      return stringArr.length > 0 && stringArr[0].length < 1
        ? route
            .replace(':companyPath?', stringArr[0])
            .substring(1)
            .replace(':token', stringArr[1])
        : route
            .replace(':companyPath?', stringArr[0])
            .replace(':token', stringArr[1]);
    }

    // Public routes with companyPath
    case ROUTES.EMAIL_VERIFICATION:
    case ROUTES.CHANGE_PASSWORD:
    case ROUTES.LOGIN: {
      if (stringArr.length > 0 && stringArr[0].length > 1) {
        return route.replace(':companyPath?', stringArr[0]);
      } else {
        return ROUTES.LOGIN_NO_BRANDING;
      }
    }

    // Routes with tenantID, entityType, and entityID
    case ROUTES.REVISIONS: {
      return route
        .replace(':tenantID', stringArr[0])
        .replace(':entityType', stringArr[1])
        .replace(':entityID', stringArr[2]);
    }

    // Routes with no parameters
    case ROUTES.INDEX:
    case ROUTES.LOGIN_NO_BRANDING:
    case ROUTES.TEST:
    default: {
      return route as string;
    }
  }
}
